import { httpRequest } from '../request';

// 获取产品层级
export function getCategoryList() {
  return httpRequest({
    url: '/accessory/category/v1/list',
    method: 'get'
  });
}
// 获取配件分类
export function getTabList(data: any) {
  return httpRequest({
    url: '/accessory/price/category/v1/list',
    method: 'get',
    data
  });
}
// 搜索接口
export function getPriceSearchList(data: any) {
  return httpRequest({
    url: '/accessory/price/search/v1/list',
    method: 'post',
    data
  });
}
